// Room type ids repeat across properties in a market search, so any per-room
// expansion state keys each card by property. Shared by the offer list, the
// availability index, and the Search route so their keys line up exactly.
export const marketGroupKey = (propertyId, roomTypeId) => `${propertyId}:${roomTypeId}`;
